//REDUCER
import {  ADD_SURVEY_ETC, RECIEVE_USER_SURVEY_ETC, SET_ETC_SURVEY_DISMISSED} from '../actions'
import { createAction, createReducer } from '@reduxjs/toolkit'


const initialState = {
	rating: null,
	dismissed: null
	
};

const surveyETC = createReducer(initialState, (builder) => {
    builder
	.addCase(createAction(RECIEVE_USER_SURVEY_ETC), (state, action) => {
        state.rating = action.json.user.surveyETC.rating;
		state.dismissed = action.json.user.surveyETC.dismissed;
	}) //not used
	.addCase(createAction(SET_ETC_SURVEY_DISMISSED, (state, action) => {
		state.dismissed = true;
	})) //not used
	.addCase(createAction(ADD_SURVEY_ETC, (state, action) => {
		state.rating = action.json.user.surveyETC.rating;
	}))

  });

export default surveyETC;

